import { useMemo } from 'react';
import { ActivityList } from 'src/components/ActivityList/activity-list';
import {
  ActivityFeedParams,
  useActivityFeed,
} from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';
import { buildMessagesByType } from './build-message-by-type';

export type SiteActivityProps = {
  addressId: string;
  partnerId: number;
};

export const SiteActivity = ({ partnerId, addressId }: SiteActivityProps) => {
  const params = useMemo<ActivityFeedParams>(
    () => ({
      identityIds: [addressId],
      partnerId,
      entityEvents: [
        {
          entityName: 'Address',
        },
        {
          entityName: 'ConversationToAddress',
        },
        {
          entityName: 'ClientToAddress',
        },
      ],
    }),
    [addressId, partnerId],
  );
  const { records, loading } = useActivityFeed(params);

  const projectParams = useMemo<ActivityFeedParams>(
    () => ({
      referenceName: 'Address',
      identityIds: [addressId],
      isRoot: false,
      partnerId,
      entityEvents: [
        {
          entityName: 'Project',
          operation: 'create',
        },
      ],
    }),
    [addressId, partnerId],
  );
  const { records: projectRecords } = useActivityFeed(projectParams);

  const items = useMemo(
    () => (records ?? []).concat(projectRecords ?? []),
    [records, projectRecords],
  );

  return <ActivityList items={items} messageBuilder={buildMessagesByType} loading={loading} />;
};
